"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2294],{

/***/ 82294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ autosuggest_card_header; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(35422);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(15015);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(85000);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(98230);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(44143);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(86533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(78391);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(28066);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(14724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(73469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/autosuggest-highlight@3.3.4/node_modules/autosuggest-highlight/match/index.js
var match = __webpack_require__(65462);
var match_default = /*#__PURE__*/__webpack_require__.n(match);
// EXTERNAL MODULE: ../../node_modules/.pnpm/autosuggest-highlight@3.3.4/node_modules/autosuggest-highlight/parse/index.js
var parse = __webpack_require__(26725);
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/findIndex.js
var findIndex = __webpack_require__(69312);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-autosuggest@9.4.3_react@17.0.2/node_modules/react-autosuggest/dist/index.js
var dist = __webpack_require__(54425);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(91697);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(172);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/InputBase/InputBase.js
var InputBase = __webpack_require__(28166);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(49653);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/red.js
var red = __webpack_require__(16438);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(5887);
;// CONCATENATED MODULE: ./components/chip-filter/chip-input.tsx
/**
 * Notice: Some code was adapted from Material-UI's text field.
 *         Copyright (c) 2014 Call-Em-All (https://github.com/callemall/material-ui)
 */ 
















var styles = function(theme) {
    var light = theme.palette.mode === "light";
    return {
        root: {
            width: "100%"
        },
        inputRoot: {
            display: "flex",
            justifyContent: "center"
        },
        input: {
            appearance: "none",
            WebkitTapHighlightColor: "rgba(0,0,0,0)"
        },
        chipContainer: {
            display: "flex",
            cursor: "text",
            alignItems: "center",
            marginBottom: -2,
            minHeight: 40,
            width: "100%"
        },
        labeled: {},
        label: {
            top: 4
        },
        labelShrink: {
            top: 0
        },
        helperText: {
            marginBottom: -20
        },
        inkbar: {
            "&:after": {
                backgroundColor: theme.palette.primary[light ? "dark" : "light"],
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                height: 2,
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: theme.transitions.create("transform", {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: "none"
            },
            "&$focused:after": {
                transform: "scaleX(1)"
            }
        },
        focused: {},
        disabled: {},
        error: {
            "&:after": {
                backgroundColor: red/* default.A400 */.Z.A400,
                transform: "scaleX(1)"
            }
        },
        chip: {
            marginRight: theme.spacing(1)
        }
    };
};
var defaultChipRenderer = function(param, key) {
    var value = param.value, text = param.text, isFocused = param.isFocused, isDisabled = param.isDisabled, handleClick = param.handleClick, handleDelete = param.handleDelete, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        className: className,
        style: {
            pointerEvents: isDisabled ? "none" : undefined,
            backgroundColor: isFocused ? "blue" : undefined
        },
        onClick: handleClick,
        onDelete: handleDelete,
        label: text
    }, key);
};
var ChipInput = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ChipInput, _Component);
    var _super = (0,_create_super/* default */.Z)(ChipInput);
    function ChipInput() {
        (0,_class_call_check/* default */.Z)(this, ChipInput);
        var _this;
        var ref, ref1;
        _this = _super.apply(this, arguments);
        _this.state = {
            isFocused: false,
            isClean: true,
            chips: [],
            focusedChip: null,
            inputValue: (ref = _this.props) === null || ref === void 0 ? void 0 : ref.inputValue,
            clearInputValueOnChange: _this.props.clearInputValueOnChange,
            value: (ref1 = _this.props) === null || ref1 === void 0 ? void 0 : ref1.value
        };
        /**
   * Focuses this component.
   * @public
   */ _this.focus = function() {
            if (_this.actualInput) {
                _this.actualInput.focus();
            }
            // this.getInputNode().focus()
            // if (this.props.openOnFocus && !this.props.disabled) {
            // }
            if (_this.state.focusedChip) {
                _this.setState({
                    focusedChip: null
                });
            }
        };
        _this.handleInputBlur = function() {
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
            _this.setState({
                isFocused: false
            });
            if (_this.state.focusedChip) {
                _this.setState({
                    focusedChip: null
                });
            }
            if (_this.props.inputValue) {
                var numChipsBefore = (_this.props.value || _this.state.chips).length;
                var value = _this.props.inputValue;
            // this.inputBlurTimeout = setTimeout(() => {
            //   const numChipsAfter = (this.props.value || this.state.chips).length;
            //   if (numChipsBefore === numChipsAfter) {
            //     this.handleAddChip(value);
            //   } else {
            //     // this.clearInput();
            //   }
            // }, 150);
            }
        };
        _this.handleInputFocus = function(event1) {
            _this.setState({
                isFocused: true
            });
            if (_this.props.onFocus) {
                _this.props.onFocus(event1);
            }
        };
        _this.handleKeyDown = function(event1) {
            var focusedChip = _this.state.focusedChip;
            _this.setState({
                keyPressed: false,
                preventChipCreation: false
            });
            if (_this.props.onKeyDown) {
                // Needed for arrow controls on menu in autocomplete scenario
                _this.props.onKeyDown(event1);
                // Check if the callback marked the event as isDefaultPrevented() and skip further actions
                // enter key for example should not always add the current value of the inputField
                if (event1.isDefaultPrevented()) {
                    return;
                }
            }
            if (_this.props.newChipKeyCodes.indexOf(event1.keyCode) >= 0) {
                if (_this.props.onEnter) {
                    _this.props.onEnter(event1);
                } else {
                // const result = this.handleAddChip(event.target.value);
                // if (result !== false) {
                //   event.preventDefault();
                // }
                }
            } else if (event1.keyCode === 8 || event1.keyCode === 46) {
                if (event1.target.value === "") {
                    var chips = _this.props.value || _this.state.chips;
                    if (focusedChip === null && event1.keyCode === 8) {
                        _this.setState({
                            focusedChip: chips.length - 1
                        });
                    } else if (focusedChip !== null) {
                        var chipsInner = _this.props.value || _this.state.chips;
                        var value = chipsInner[focusedChip];
                        _this.handleDeleteChip(value, focusedChip);
                        if (event1.keyCode === 8 && focusedChip > 0) {
                            _this.setState({
                                focusedChip: focusedChip - 1
                            });
                        } else if (event1.keyCode === 46 && focusedChip <= chipsInner.length - 1) {
                            _this.setState({
                                focusedChip: focusedChip
                            });
                        }
                    }
                }
            } else if (event1.keyCode === 37) {
                var chips1 = _this.props.value || _this.state.chips;
                if (focusedChip === null && event1.target.value === "" && chips1.length) {
                    return _this.setState({
                        focusedChip: chips1.length - 1
                    });
                }
                if (focusedChip !== null && focusedChip > 0) {
                    _this.setState({
                        focusedChip: focusedChip - 1
                    });
                }
            } else if (event1.keyCode === 39) {
                var chips2 = _this.props.value || _this.state.chips;
                if (focusedChip !== null && focusedChip < chips2.length - 1) {
                    _this.setState({
                        focusedChip: focusedChip + 1
                    });
                } else {
                    _this.setState({
                        focusedChip: null
                    });
                }
            } else {
                _this.setState({
                    focusedChip: null
                });
            }
        };
        _this.handleKeyUp = function(event1) {
            if (!_this.state.preventChipCreation && _this.props.newChipKeyCodes.indexOf(event1.keyCode) > 0 && _this.state.keyPressed) {
                _this.clearInput();
            } else {
                if (!_this.props.inputValue) {
                    _this.setState({
                        inputValue: event1.target.value
                    });
                }
            }
        };
        _this.handleKeyPress = function(event1) {
            _this.setState({
                keyPressed: true
            });
        };
        _this.handleUpdateInput = function(e) {
            if (!_this.props.inputValue) {
                _this.setState({
                    inputValue: e.target.value
                });
            }
            if (_this.props.onUpdateInput) {
                _this.props.onUpdateInput(e);
            }
        };
        /**
   * Sets a reference to the Material-UI Input component.
   * @param {object} input - The Input reference
   */ _this.setInputRef = function(input) {
            _this.input = input;
        };
        /**
   * Set the reference to the actual input, that is the input of the Input.
   * @param {object} ref - The reference
   */ _this.setActualInputRef = function(ref) {
            _this.actualInput = ref;
            if (_this.props.inputRef) {
                _this.props.inputRef(ref);
            }
        };
        return _this;
    }
    var _proto = ChipInput.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.inputBlurTimeout) {
            clearTimeout(this.inputBlurTimeout);
        }
    };
    /**
   * Blurs this component.
   * @public
   */ _proto.blur = function blur() {
        if (this.actualInput) {
            this.actualInput.blur();
        }
    };
    _proto.handleDeleteChip = function handleDeleteChip(chip, i) {
        if (this.props.value) {
            if (this.props.onDelete && typeof chip === "object") {
                this.props.onDelete(chip, i);
            }
        } else {
            var chips = this.state.chips.slice();
            var changed = chips.splice(i, 1); // remove the chip at index i
            if (changed) {
                var focusedChip = this.state.focusedChip;
                if (focusedChip !== null) {
                    switch(true){
                        case focusedChip === i:
                            focusedChip = null;
                            break;
                        case focusedChip > i:
                            focusedChip--;
                            break;
                        default:
                            break;
                    }
                }
                this.setState({
                    chips: chips,
                    focusedChip: focusedChip
                });
            }
        }
    };
    /**
   * Clears the text field for adding new chips.
   * @public
   */ _proto.clearInput = function clearInput() {
        if (!this.props.inputValue) {
            this.setState({
                inputValue: ""
            });
        }
        if (this.props.onUpdateInput) {
            this.props.onUpdateInput({
                target: {
                    value: ""
                }
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, allowDuplicates = _props.allowDuplicates, children = _props.children, _chipRenderer = _props.chipRenderer, chipRenderer = _chipRenderer === void 0 ? defaultChipRenderer : _chipRenderer, classes = _props.classes, className = _props.className, clearInputValueOnChange = _props.clearInputValueOnChange, dataSourceConfig = _props.dataSourceConfig, inputValue = _props.inputValue, disabled = _props.disabled, error = _props.error, FormHelperTextProps = _props.FormHelperTextProps, fullWidth = _props.fullWidth, fullWidthInput = _props.fullWidthInput, helperText = _props.helperText, id = _props.id, InputProps = _props.InputProps, inputRef = _props.inputRef, InputLabelProps = _props.InputLabelProps, label = _props.label, newChipKeyCodes = _props.newChipKeyCodes, onAdd = _props.onAdd, onBlur = _props.onBlur, onDelete = _props.onDelete, onFocus = _props.onFocus, onKeyDown = _props.onKeyDown, onEnter = _props.onEnter, onUpdateInput = _props.onUpdateInput, placeholder = _props.placeholder, required = _props.required, rootRef = _props.rootRef, value = _props.value, other = (0,_object_without_properties/* default */.Z)(_props, [
            "allowDuplicates",
            "children",
            "chipRenderer",
            "classes",
            "className",
            "clearInputValueOnChange",
            "dataSourceConfig",
            "inputValue",
            "disabled",
            "error",
            "FormHelperTextProps",
            "fullWidth",
            "fullWidthInput",
            "helperText",
            "id",
            "InputProps",
            "inputRef",
            "InputLabelProps",
            "label",
            "newChipKeyCodes",
            "onAdd",
            "onBlur",
            "onDelete",
            "onFocus",
            "onKeyDown",
            "onEnter",
            "onUpdateInput",
            "placeholder",
            "required",
            "rootRef",
            "value"
        ]);
        var chips = this.props.value || this.state.chips;
        var chipInputValue = onUpdateInput ? inputValue : this.state.inputValue;
        var ref;
        var hasInput = chips.length > 0 || ((ref = chipInputValue === null || chipInputValue === void 0 ? void 0 : chipInputValue.length) !== null && ref !== void 0 ? ref : 0) > 0;
        var shrinkFloatingLabel = label !== null && (hasInput || this.state.isFocused);
        var _obj;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            variant: "standard",
            // ref={rootRef}
            fullWidth: fullWidth,
            className: (0,clsx_m["default"])(className, classes.root),
            error: !!error,
            required: required,
            onClick: this.focus,
            disabled: disabled
        }, other), {
            children: [
                label && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    htmlFor: String(id),
                    classes: {
                        root: classes.label,
                        shrink: classes.labelShrink
                    },
                    shrink: shrinkFloatingLabel,
                    focused: this.state.isFocused
                }, InputLabelProps), {
                    children: label
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m["default"])(classes.chipContainer, (_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.focused, this.state.isFocused), (0,_define_property/* default */.Z)(_obj, classes.disabled, disabled), (0,_define_property/* default */.Z)(_obj, classes.labeled, label !== null), (0,_define_property/* default */.Z)(_obj, classes.error, !!error), _obj)),
                    children: [
                        chips.map(function(tag, i) {
                            var chipValue = dataSourceConfig ? tag[dataSourceConfig.value] : tag;
                            return chipRenderer({
                                value: chipValue,
                                text: dataSourceConfig ? tag[dataSourceConfig.text] : tag,
                                chip: tag,
                                isDisabled: !!disabled,
                                isFocused: _this.state.focusedChip === i,
                                handleClick: function() {
                                    _this.setState({
                                        focusedChip: i
                                    });
                                // if (this.state.focusedChip === i) {
                                //   this.handleEditChip(chipValue, i);
                                // } else {
                                //   this.setState({ focusedChip: i });
                                // }
                                },
                                handleDelete: function() {
                                    return _this.handleDeleteChip(chipValue, i);
                                },
                                className: classes.chip
                            }, String(i));
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, (0,_object_spread/* default */.Z)({
                            // ref={this.setInputRef}
                            classes: {
                                input: classes.input,
                                root: classes.inputRoot
                            },
                            id: String(id),
                            value: chipInputValue,
                            onChange: this.handleUpdateInput,
                            onKeyDown: this.handleKeyDown,
                            onKeyPress: this.handleKeyPress,
                            onKeyUp: this.handleKeyUp,
                            onFocus: this.handleInputFocus,
                            onBlur: this.handleInputBlur,
                            inputRef: this.setActualInputRef,
                            disabled: disabled,
                            fullWidth: fullWidthInput,
                            placeholder: !hasInput && (shrinkFloatingLabel || !label) ? placeholder : undefined
                        }, other, InputProps))
                    ]
                }),
                helperText && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, FormHelperTextProps), {
                    className: FormHelperTextProps ? (0,clsx_m["default"])(FormHelperTextProps.className, classes.helperText) : classes.helperText,
                    children: helperText
                }))
            ]
        }));
    };
    ChipInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var ref;
        if (nextProps.disabled) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                focusedChip: null
            });
        }
        if (nextProps.value && prevState.clearInputValueOnChange && nextProps.value.length !== ((ref = prevState.value) === null || ref === void 0 ? void 0 : ref.length)) {
            if (prevState.inputValue && nextProps.onUpdateInput) {
                nextProps.onUpdateInput({
                    target: {
                        value: ""
                    }
                });
            } else {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    inputValue: ""
                });
            }
        }
        return prevState;
    };
    return ChipInput;
}(react.Component);
/* harmony default export */ var chip_input = ((0,with_styles/* withStyles */.D)(styles)(ChipInput));

;// CONCATENATED MODULE: ./components/chip-filter/autosuggest-chip-input.tsx























var autosuggest_chip_input_styles = function(theme) {
    return {
        container: {
            flexGrow: 0,
            position: "relative"
        },
        suggestionsContainerOpen: {
            position: "absolute",
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
            maxHeight: 300,
            maxWidth: 400,
            overflowY: "auto",
            left: 0,
            zIndex: 100,
            right: 0
        },
        suggestion: {
            display: "block"
        },
        suggestionsList: {
            margin: 0,
            padding: 0,
            listStyleType: "none"
        },
        textField: {
            width: "100%"
        },
        discardGrid: {
            direction: "rtl"
        },
        discardButton: {
            padding: 8
        }
    };
};
var AutosuggestChipInput = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(AutosuggestChipInput, _Component);
    var _super = (0,_create_super/* default */.Z)(AutosuggestChipInput);
    function AutosuggestChipInput() {
        (0,_class_call_check/* default */.Z)(this, AutosuggestChipInput);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            value: [],
            suggestions: [],
            textFieldInput: ""
        };
        _this.justClicked = false;
        _this.chipRenderer = function(param, key) {
            var chip = param.chip, isFocused = param.isFocused, isDisabled = param.isDisabled, handleClick = param.handleClick, handleDelete = param.handleDelete, className = param.className;
            var chipKey;
            var chipName;
            if (chip.key === "search") {
                chipKey = _this.props.t([
                    "shared:search"
                ], {
                    defaultValue: "Search"
                });
                chipName = chip.value;
            } else if (chip.key === "name") {
                chipKey = _this.props.t([
                    "shared:name"
                ], {
                    defaultValue: "Name"
                });
                chipName = chip.value;
            } else {
                var ref = (0,_sliced_to_array/* default */.Z)(_this.props.suggestions.filter(function(s) {
                    return chip.key.toUpperCase() === s.key.toUpperCase();
                }), 1), suggestion = ref[0];
                if (!suggestion) {
                    return null;
                }
                var ref1 = (0,_sliced_to_array/* default */.Z)(suggestion.options.filter(function(o) {
                    var ref;
                    return ((ref = o.value) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === chip.value.toUpperCase();
                }), 1), option = ref1[0];
                if (!option) {
                    return null;
                }
                chipKey = suggestion.name;
                chipName = option === null || option === void 0 ? void 0 : option.name;
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                className: className,
                style: {
                    pointerEvents: isDisabled ? "none" : undefined,
                    backgroundColor: isFocused ? _this.props.theme.palette.primary.main : undefined,
                    cursor: isFocused ? "text" : "pointer"
                },
                onClick: handleClick,
                onDelete: handleDelete,
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: chipKey
                        }),
                        ":",
                        chipName
                    ]
                })
            }, key);
        };
        _this.renderInput = function(_param) {
            var classes = _param.classes, autoFocus = _param.autoFocus, value = _param.value, onChange = _param.onChange, onAdd = _param.onAdd, onDelete = _param.onDelete, chips = _param.chips, ref = _param.ref, other = (0,_object_without_properties/* default */.Z)(_param, [
                "classes",
                "autoFocus",
                "value",
                "onChange",
                "onAdd",
                "onDelete",
                "chips",
                "ref"
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(chip_input, (0,_object_spread/* default */.Z)({
                allowDuplicates: false,
                clearInputValueOnChange: false,
                newChipKeyCodes: [
                    13
                ],
                chipRenderer: _this.chipRenderer,
                onUpdateInput: onChange,
                onAdd: onAdd,
                onDelete: onDelete,
                inputValue: value,
                value: chips,
                inputRef: ref,
                placeholder: _this.props.placeholderText ? _this.props.placeholderText : _this.props.t([
                    "shared:filterValues"
                ], {
                    defaultValue: "Filter values.."
                })
            }, other));
        };
        _this.renderSuggestion = function(suggestion, param) {
            var query = param.query, isHighlighted = param.isHighlighted;
            if (_this.currentKey) {
                query = query.toLowerCase().split("".concat(_this.currentKey.toLowerCase(), ":"))[1];
            }
            var matches = match_default()(suggestion.name, query);
            var parts = parse_default()(suggestion.name, matches);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                selected: isHighlighted,
                component: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: parts.map(function(part, index) {
                        return part.highlight ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                color: _this.props.theme.palette.primary.main,
                                fontWeight: 500
                            },
                            children: part.text
                        }, String(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            style: {
                                fontWeight: 500
                            },
                            children: part.text
                        }, String(index));
                    })
                })
            });
        };
        _this.renderSuggestionsContainer = function(param) {
            var containerProps = param.containerProps, children = param.children;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
                square: true,
                children: children
            }));
        };
        _this.escapeRegexCharacters = function(str) {
            return str ? str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : [];
        };
        _this.getSuggestions = function(value) {
            var returnSuggestions = _this.props.suggestions;
            var testValue = value.trim();
            if (_this.currentKey) {
                var index = findIndex_default()(_this.props.suggestions, function(s) {
                    return s.name === _this.currentKey;
                });
                returnSuggestions = _this.props.suggestions[index].options;
                testValue = testValue.toLowerCase().split("".concat(_this.currentKey.toLowerCase(), ":"))[1];
                if (testValue === undefined) {
                    testValue = "";
                }
            }
            var escapedValue = _this.escapeRegexCharacters(testValue.trim());
            if (escapedValue === "") {
                return returnSuggestions;
            }
            return returnSuggestions;
        };
        _this.getSuggestionValue = function(suggestion) {
            return suggestion.name;
        };
        _this.shouldRenderSuggestions = function() {
            return true;
        };
        _this.handleSuggestionsFetchRequested = function(param) {
            var value = param.value;
            _this.setState({
                suggestions: _this.getSuggestions(value)
            });
        };
        _this.handleSuggestionsClearRequested = function() {
            _this.setState({
                suggestions: _this.props.suggestions
            });
        };
        _this.handletextFieldInputChange = function(event, param) {
            var newValue = param.newValue, method = param.method;
            if (method === "click" || method === "enter") {
                event.preventDefault();
                return;
            }
            if ((method === "up" || method === "down") && _this.currentKey !== newValue.split(":").shift()) {
                if (_this.currentKey) {
                    newValue = _this.currentKey + ": " + newValue;
                } else {
                    newValue = newValue;
                }
            }
            if (!newValue && method === "type" && _this.state.textFieldInput.length > 1) {
                newValue = _this.state.textFieldInput;
            }
            if (method === "type" && newValue) {
                if (!_this.justClicked) {
                    var matchingSuggestions = _this.props.suggestions.filter(function(suggestion) {
                        var suggestionRegex = new RegExp("^" + _this.escapeRegexCharacters(suggestion.name) + ":", "i");
                        return suggestionRegex.test(newValue.trim());
                    });
                    if (matchingSuggestions.length) {
                        _this.currentKey = matchingSuggestions[0].name;
                    // this.setState({
                    //   currentKey: matchingSuggestions[0].name,
                    // });
                    } else {
                        _this.currentKey = undefined;
                    // this.setState({
                    //   currentKey: undefined,
                    // });
                    }
                } else {
                    _this.justClicked = false;
                // this.setState({
                //   justClicked: false,
                // });
                }
            }
            if (method === "type" || method === "up" || method === "down") {
                _this.setState({
                    textFieldInput: newValue
                });
            }
        };
        _this.handleAddChip = function(chip) {
            var ref;
            var key = "search";
            var value = chip;
            var index;
            if (_this.currentKey) {
                // In this case, the textFieldValue contains both a suggestion and a value, seperated by ':'
                index = findIndex_default()(_this.props.suggestions, function(s) {
                    return s.name === _this.currentKey;
                });
                key = _this.props.suggestions[index].key ? _this.props.suggestions[index].key : _this.props.suggestions[index].name;
                value = chip.toLowerCase().split("".concat(_this.currentKey.toLowerCase(), ":"))[1];
                var validOptions = _this.props.suggestions[index].options.map(function(s) {
                    var ref;
                    return typeof s.name === "string" ? (ref = s.value) === null || ref === void 0 ? void 0 : ref.toLowerCase() : "";
                });
                if (value && !validOptions.includes(value.trim())) {
                    _this.setState({
                        textFieldInput: key + ":"
                    });
                    return null;
                }
            } else if (chip.startsWith("".concat(key, ":"))) {
                value = chip.toLowerCase().split("".concat(key, ":"))[1];
            }
            if (!value) {
                return null;
            }
            // Here the key and value is guaranteed to be set, where key is either a suggestion name or 'search'
            var stateValue = _this.state.value;
            if ((ref = _this.props.suggestions[index !== null && index !== void 0 ? index : -1]) === null || ref === void 0 ? void 0 : ref.justOne) {
                stateValue = stateValue.filter(function(item) {
                    return item.key !== key;
                });
            }
            stateValue = (0,_to_consumable_array/* default */.Z)(stateValue).concat([
                {
                    key: key,
                    value: value.trim()
                }
            ]);
            _this.setState({
                value: stateValue,
                textFieldInput: ""
            });
            _this.handleSuggestionsFetchRequested({
                value: ""
            });
            if (_this.props.applyFilter) {
                _this.props.applyFilter(stateValue);
            }
            _this.currentKey = undefined;
            return true;
        };
        _this.handleOnInputEnter = function(event) {
            if (event.target.value.trim().length) {
                var result = _this.handleAddChip(event.target.value);
                if (result) {
                    _this.currentKey = undefined;
                    _this.handleSuggestionsClearRequested();
                    _this.handleSuggestionsFetchRequested({
                        value: ""
                    });
                }
            }
        };
        _this.clear = function() {
            _this.setState({
                value: [],
                textFieldInput: ""
            }, function() {
                if (!_this.props.applyFilter) {
                    return;
                }
                delete _this.currentKey;
                _this.props.applyFilter([]);
            });
        };
        _this.onSuggestionSelected = function(_, args) {
            var suggestionValue = args.suggestionValue;
            _this.justClicked = true;
            if (_this.currentKey) {
                var index = findIndex_default()(_this.props.suggestions, function(s) {
                    return s.name === _this.currentKey;
                });
                var suggestionIndex = _this.props.suggestions[index].options.findIndex(function(o) {
                    return o.name === suggestionValue;
                });
                var value = _this.props.suggestions[index].options[suggestionIndex].value;
                var chip = _this.currentKey + ": " + value;
                _this.handleAddChip(chip);
            } else {
                _this.currentKey = suggestionValue;
                _this.setState({
                    // currentKey: suggestionValue,
                    textFieldInput: suggestionValue + ": "
                });
                setTimeout(function() {
                    _this.handleSuggestionsFetchRequested({
                        value: suggestionValue + ": "
                    });
                }, 10);
            }
        };
        return _this;
    }
    var _proto = AutosuggestChipInput.prototype;
    _proto.handleDeleteChip = function handleDeleteChip(_, index) {
        // chips.splice(index, 1);
        var newChips = this.state.value.filter(function(__, i) {
            return i !== index;
        });
        this.setState({
            value: newChips
        });
        if (this.props.applyFilter) {
            this.props.applyFilter(newChips);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var classes = this.props.classes;
        // FIXME: Autosuggest does not infer inputProps to renderInputComponent,
        // hence the cast.
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 11,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                        theme: {
                            container: classes.container,
                            suggestionsContainerOpen: classes.suggestionsContainerOpen,
                            suggestionsList: classes.suggestionsList,
                            suggestion: classes.suggestion
                        },
                        renderInputComponent: this.renderInput,
                        suggestions: this.state.suggestions,
                        onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
                        onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
                        renderSuggestionsContainer: this.renderSuggestionsContainer,
                        getSuggestionValue: this.getSuggestionValue,
                        shouldRenderSuggestions: this.shouldRenderSuggestions,
                        renderSuggestion: this.renderSuggestion,
                        onSuggestionSelected: this.onSuggestionSelected,
                        focusInputOnSuggestionClick: Boolean(this.state.textFieldInput) ? false : true,
                        inputProps: {
                            classes: classes,
                            chips: this.state.value,
                            onChange: this.handletextFieldInputChange,
                            value: this.state.textFieldInput,
                            onAdd: function(chip) {
                                return _this.handleAddChip(chip);
                            },
                            onEnter: function(e) {
                                return _this.handleOnInputEnter(e);
                            },
                            onDelete: function(chip, index) {
                                return _this.handleDeleteChip(chip, index);
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 1,
                    className: classes.discardGrid,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: this.clear,
                        disabled: !this.state.textFieldInput.length && !this.state.value.length,
                        className: classes.discardButton,
                        size: "large",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                })
            ]
        });
    };
    AutosuggestChipInput.getDerivedStateFromProps = function getDerivedStateFromProps(_param, _param1) {
        var _filters = _param.filters, filters = _filters === void 0 ? [] : _filters, _suggestions = _param.suggestions, suggestions = _suggestions === void 0 ? [] : _suggestions, _value = _param1.value, value = _value === void 0 ? [] : _value, state = (0,_object_without_properties/* default */.Z)(_param1, [
            "value"
        ]);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            value: filters.concat(value).filter(function(item, idx, arr) {
                if (item.key.toUpperCase() !== "SEARCH" && !suggestions.some(function(suggestion) {
                    return item.key.toUpperCase() === suggestion.key.toUpperCase();
                })) {
                    return false;
                }
                return arr.findIndex(function(i) {
                    return i.key === item.key && i.value === item.value;
                }) === idx;
            })
        });
    };
    return AutosuggestChipInput;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,with_styles/* withStyles */.D)(autosuggest_chip_input_styles, {
    withTheme: true
}));
/* harmony default export */ var autosuggest_chip_input = (enhance(AutosuggestChipInput));

;// CONCATENATED MODULE: ./components/chip-filter/autosuggest-card-header.tsx








var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        action: {
            marginTop: 0,
            alignSelf: "normal",
            display: "flex",
            alignItems: "center",
            marginLeft: theme.spacing()
        }
    };
});
var AutosuggestCardHeader = function(param) {
    var suggestions = param.suggestions, applyFilter = param.applyFilter, filters = param.filters, t = param.t, placeholderText = param.placeholderText, action = param.action;
    var theme = (0,useTheme/* default */.Z)();
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                classes: {
                    action: classes.action
                },
                action: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: action
                }),
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                    style: {
                        backgroundColor: theme.palette.primary.main
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(autosuggest_chip_input, {
                    suggestions: suggestions,
                    applyFilter: applyFilter,
                    filters: filters,
                    t: t,
                    placeholderText: placeholderText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var autosuggest_card_header = (AutosuggestCardHeader);


/***/ })

}]);